const MODULE_NAME = 'fulcrum/container/Report/Dashboard'

const MOUNT = MODULE_NAME + '/MOUNT'
const UNMOUNT = MODULE_NAME + '/UNMOUNT'

const FETCH_REPORT = MODULE_NAME + '/FETCH_REPORT'
const FETCH_REPORT_START = MODULE_NAME + '/FETCH_REPORT_START'
const FETCH_REPORT_SUCCESS = MODULE_NAME + '/FETCH_REPORT_SUCCESS'
const FETCH_REPORT_ERROR = MODULE_NAME + '/FETCH_REPORT_ERROR'

const UPDATE_REPORT = MODULE_NAME + '/UPDATE_REPORT'
const REMOVE_REPORT = MODULE_NAME + '/REMOVE_REPORT'
const CLEAR_REPORTS = MODULE_NAME + '/CLEAR_REPORTS'

const ON_SELECT_FILTER = MODULE_NAME + '/ON_SELECT_FILTER'
const ON_UNSELECT_FILTER = MODULE_NAME + '/ON_UNSELECT_FILTER'
const CLEAR_FILTER = MODULE_NAME + '/CLEAR_FILTER'

const UPDATE_QUERY = MODULE_NAME + '/UPDATE_QUERY'
const UPDATE_QUERY_CHANGES = MODULE_NAME + '/UPDATE_QUERY_CHANGES'
const UPDATE_QUERY_SOURCE = MODULE_NAME + '/UPDATE_QUERY_SOURCE'
const RESET_QUERY = MODULE_NAME + '/RESET_QUERY'

const UPDATE_PROJECT_COUNTS_QUERY = MODULE_NAME + '/UPDATE_PROJECT_COUNTS_QUERY'
const UPDATE_PROJECT_SPECIFICATION_QUERY = MODULE_NAME + 'UPDATE_PROJECT_SPECIFICATION_QUERY'
const UPDATE_AE_RESOURCES_QUERY = MODULE_NAME + '/UPDATE_AE_RESOURCES_QUERY'
const UPDATE_AE_REGIONS_QUERY = MODULE_NAME + '/UPDATE_AE_REGIONS_QUERY'

const ADD_SPECIFICATION_CHART = MODULE_NAME + 'ADD_SPECIFICATION_CHART'
const REMOVE_SPECIFICATION_CHART = MODULE_NAME + 'REMOVE_SPECIFICATION_CHART'

const TOGGLE_DASHBOARD_QUERY = MODULE_NAME + '/TOGGLE_DASHBOARD_QUERY'


const attributesEnum = Object.freeze({
  CLOCK: {
    label: 'Clock',
    options: [
      { value: 'base_clock', label: 'Base Clock', parent: 'clock' },
      { value: 'boost_clock', label: 'Boost Clock', parent: 'clock' },
      { value: 'vf_offset', label: 'VF Offset', parent: 'clock' }
    ]
  },
  DISPLAY: {
    label: 'Display',
    options: [
      { value: 'connector_type', label: 'Display Connector Type', parent: 'display_connector' },
    ]
  },
  MEMORY: {
    label: 'Memory',
    options: [
      { value: 'clock', label: 'Memory Clock', parent: 'memory' },
      { value: 'config', label: 'Memory Config', parent: 'memory' }
    ]
  },
  PCB: {
    label: 'PCB',
    options: [
      { value: 'value', label: 'PCB Technology', parent: 'pcb_technology' },
      { value: 'value', label: 'PCB Material', parent: 'pcb_material' }
    ]
  },
  NOTEBOOK_PANEL: {
    label: 'Notebook Panel',
    options: [
      { value: 'size', label: 'Panel Size', parent: 'panel' }
    ]
  },
  POWER: {
    label: 'Power',
    options: [
      { value: 'value', label: 'Notebook Batery Size', parent: 'battery_size' },
      { value: 'value', label: 'Power TGP Max', parent: 'power_tgp_max' },
      { value: 'value', label: 'Power TGP Rated', parent: 'power_tgp_rated' }
    ]
  },
  SYSTEM_MECHANICAL: {
    label: 'System Mechanical',
    options: [
      { value: 'value', label: 'Chassis Height', parent: 'chassis_height' },
      { value: 'value', label: 'Chassis Length', parent: 'chassis_length' },
      { value: 'value', label: 'Chassis Width', parent: 'chassis_width' }
    ]
  }
})


const chartsEnum = Object.freeze({
  TOTAL_COUNTS: {
    value: 'project_counts',
    label: 'Total Counts',
    multi: false,
    restricted: false
  },
  SCHEDULE_TRENDLINE: {
    value: 'project_schedule_trendline',
    label: 'Schedule Trendline',
    multi: false,
    restricted: false
  },
  LIFECYCLE_TRENDLINE: {
    value: 'project_lifecycle_trendline',
    label: 'Lifecycle Trendline',
    multi: false,
    restricted: false
  },
  LIFECYCLE_STATUS: {
    value: 'project_lifecycle_status',
    label: 'Lifecycle Status',
    multi: false,
    restricted: false
  },
  SPECIFICATION: {
    value: 'project_specification',
    label: 'Specification',
    default: attributesEnum.CLOCK.options[0],
    multi: true,
    restricted: false
  },
  PARTNER_LIFECYCLE: {
    value: 'partner_lifecycle_status',
    label: 'Lifecycle Status',
    multi: false,
    restricted: false
  },
  AE_RESOURCES: {
    value: 'ae_resources',
    label: 'Resources',
    multi: true,
    restricted: false
  },
  AE_REGIONS: {
    value: 'ae_regions',
    label: 'Regions',
    multi: false,
    restricted: true
  },
})

const chartCategoryEnum = Object.freeze({
  PROJECT: {
    value: 'Project',
    charts: [chartsEnum.TOTAL_COUNTS, chartsEnum.SCHEDULE_TRENDLINE, chartsEnum.LIFECYCLE_TRENDLINE, chartsEnum.LIFECYCLE_STATUS, chartsEnum.SPECIFICATION]
  },
  PARTNER: {
    value: 'Partner',
    charts: [chartsEnum.PARTNER_LIFECYCLE]
  },
  AE: {
    value: 'AE',
    charts: [chartsEnum.AE_RESOURCES, chartsEnum.AE_REGIONS]
  }
})

const lifecyclesEnum = Object.freeze({
  QUALIFICATION: {
    value: 'qualification',
    label: 'Qualification'
  },
  DESIGN_REVIEW: {
    value: 'design_review',
    label: 'Design Review'
  },
  MASS_PRODUCTION: {
    value: 'mass_production',
    label: 'Mass Production'
  }
})

const segmentsEnum = Object.freeze({
  DESKTOP: {
    value: 'Desktop',
    label: 'Desktop'
  },
  NOTEBOOK: {
    value: 'Notebook',
    label: 'Notebook'
  },
  ENTERPRISE: {
    value: 'Enterprise',
    label: 'Enterprise'
  }
})

const PartnerSiteEnum = Object.freeze({
  // PARTNER: {
  //   value: 0,
  //   label: 'Partner',
  //   filter: 'partner',
  //   source: 'partner'
  // },
  // ODM: {
  //   value: 1,
  //   label: 'ODM',
  //   filter: 'odm',
  //   source: 'odm'
  // },
  PARTNER_SITE: {
    value: 2,
    label: 'Partner Site',
    filter: 'partner_site_name',
    source: 'name'
  }
})

const AeRegionEnum = Object.freeze({
  AE_REGION: {
    value: 1,
    label: 'AE Region',
    filter: 'ae_region_id',
    source: 'name'
  }
})

const ProductHierarchyEnum = Object.freeze({
  SEGMENT: {
    value: 1,
    label: 'Segment',
    filter: 'segment'
  },
  LINE: {
    value: 2,
    label: 'Line',
    filter: 'line'
  },
  FAMILY: {
    value: 3,
    label: 'Family',
    filter: 'family'
  },
  SKU: {
    value: 5,
    label: 'Sku',
    filter: 'product_sku'
  }
})

const regionsEnum = Object.freeze({
  SANTA_CLARA: {
    value: 'Santa Clara, USA',
    label: 'Santa Clara, USA'
  },
  SEOUL: {
    value: 'Seoul, Korea',
    label: 'Seoul, Korea'
  },
  SHANGHAI: {
    value: 'Shanghai, China',
    label: 'Shanghai, China'
  },
  SHENZHEN: {
    value: 'Shenzhen, China',
    label: 'Shenzhen, China'
  },
  TAIPEI: {
    value: 'Taipei, Taiwan',
    label: 'Taipei, Taiwan'
  }
})

export {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  FETCH_REPORT,
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
  UPDATE_REPORT,
  REMOVE_REPORT,
  CLEAR_REPORTS,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  CLEAR_FILTER,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_QUERY_SOURCE,
  RESET_QUERY,
  UPDATE_PROJECT_COUNTS_QUERY,
  UPDATE_PROJECT_SPECIFICATION_QUERY,
  UPDATE_AE_RESOURCES_QUERY,
  UPDATE_AE_REGIONS_QUERY,
  ADD_SPECIFICATION_CHART,
  REMOVE_SPECIFICATION_CHART,
  TOGGLE_DASHBOARD_QUERY,
  chartsEnum,
  chartCategoryEnum,
  lifecyclesEnum,
  ProductHierarchyEnum,
  PartnerSiteEnum,
  AeRegionEnum,
  attributesEnum,
  segmentsEnum,
  regionsEnum
}
